import { render, staticRenderFns } from "./ViewSettingsLogs.vue?vue&type=template&id=e19a3134&scoped=true&"
import script from "./ViewSettingsLogs.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsLogs.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsLogs.vue?vue&type=style&index=0&id=e19a3134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19a3134",
  null
  
)

export default component.exports